export enum InfluencerDialogType {
  NewInfluencerManual = "NewInfluencerManual",
  BulkUpload = "BulkUpload",
  ViewInfluencer = "ViewInfluencer",
  EditInfluencer = "EditInfluencer",
}
